// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as CatalogRoutes from "../../app/Catalog/CatalogRoutes.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogProductEditForm from "./CatalogProductEditForm.res.js";
import * as CatalogVariantEditUrlState from "./CatalogVariantEditUrlState.res.js";
import * as CatalogProductEditFormMutations from "./CatalogProductEditFormMutations.res.js";

function CatalogProductEditFormPageActions(props) {
  let updateProduct = CatalogProductEditFormMutations.useUpdateProduct();
  let navigate = Navigation.useNavigate();
  let match = CatalogProductEditForm.useFormState();
  let disabled = Stdlib_Option.isNone(match.values.tax);
  let onPressNextStep = React.useCallback((param, state) => {
    navigate({
      state: CatalogVariantEditUrlState.CreateVariantFromProduct.encode(state)
    }, CatalogRoutes.createRoute);
    return Future.value({
      TAG: "Ok",
      _0: undefined
    });
  }, []);
  return JsxRuntime.jsx(Inline.make, {
    children: props.editionMode ? JsxRuntime.jsx(CatalogProductEditForm.SubmitButton.make, {
        label: I18n.t("Save"),
        tone: "success",
        disabled: disabled,
        onSubmit: updateProduct
      }) : JsxRuntime.jsx(CatalogProductEditForm.SubmitButton.make, {
        label: I18n.t("Continue"),
        tone: "success",
        disabled: disabled,
        onSubmit: onPressNextStep
      }),
    space: "small"
  });
}

let make = React.memo(CatalogProductEditFormPageActions);

let Mutations;

export {
  Mutations,
  make,
}
/* make Not a pure module */
